<template>
  <div class="app-logs-root" v-loading="loading">
    <div class="datePicker">
      <span class="tip">选择日期：</span>
      <div class="block">
        <el-date-picker v-model="dateRange" size="large" type="daterange" unlink-panels range-separator="至"
          start-placeholder="开始时间" end-placeholder="结束时间" :shortcuts="shortcuts" @change="getLogs" />
      </div>
    </div>
    <div class="prompt" v-if="logsData.length == 0">
      暂无数据，请选择查询日期
    </div>
    <div class="logContent">
      <el-menu mode="horizontal" default-active="1" class="el-menu-demo">
        <el-menu-item index="1" style="font-size: large">操作日志</el-menu-item>
      </el-menu>
      <el-timeline style="margin-top: 30px">
        <el-timeline-item v-for="item in logsData" :key="item.id" :timestamp="item.logtime" placement="top"
          :type="item.show ? 'primary' : 'info'" :hollow="!item.show" style="width: 98%" size="large">
          <el-card>
            <h4>{{ item.description }}: {{ item.event }}</h4>
            <p>{{ item.email }} {{ item.clientip }}</p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
      <el-button style="
          width: 90%;
          height: 40px;
          border: 1px solid #419eff;
          color: #419eff;
          margin-bottom: 20px;
          margin-left: 5%;
        " v-if="logsData.length >= 30 && !hideLoadMore" @click="getMoreLogs">
        加载更多
      </el-button>
    </div>
  </div>
</template>

<script setup>
import { getCurrentInstance, onMounted, reactive, ref, toRaw, watch } from "vue";
import { storeToRefs } from "pinia";
import { useProjectStore } from "@/Store/ProjectStore";
import { apiGetAppLog } from "@/Api/AppApi";

const projectStore = useProjectStore();
const { currentProjectId } = storeToRefs(projectStore);

const { appContext } = getCurrentInstance();
const $message = appContext.config.globalProperties.$message;

const shortcuts = [
  {
    text: "最近一周",
    value: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      return [start, end];
    },
  },
  {
    text: "最近一个月",
    value: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      return [start, end];
    },
  },
  {
    text: "最近三个月",
    value: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      return [start, end];
    },
  },
];

let dateMap = {};
const dateRange = ref(null);
const logsData = reactive([]);
const loading = ref(false);
watch(currentProjectId, (val) => {
  if (val) {
    getLogs();
  }
});
async function getLogs() {
  logsData.splice(0);
  dateMap = {};
  const data = {
    projectId: toRaw(currentProjectId.value),
    startDate: Math.floor(dateRange.value[0].getTime() / 1000),
    endDate: Math.floor(dateRange.value[1].getTime() / 1000),
    cursor: 0, // 当前条数
    count: 30, //每次加载条数
  };
  loading.value = true;
  const res = await apiGetAppLog(data);
  loading.value = false;
  hideLoadMore.value = false;
  if (res.code === 0) {
    const data = res.data?.data || [];
    data.forEach(log => {
      log.logtime = log.logtime.split('T')[0];
      if (dateMap[log.logtime]) {
        log.show = false;
      } else {
        log.show = true;
        dateMap[log.logtime] = true;
      }
    });
    logsData.push(...data);
  } else {
    $message.error(res.message);
  }
}
const hideLoadMore = ref(false);
async function getMoreLogs() {
  const data = {
    projectId: toRaw(currentProjectId.value),
    startDate: Math.floor(dateRange.value[0].getTime() / 1000),
    endDate: Math.floor(dateRange.value[1].getTime() / 1000),
    cursor: logsData.length, // 当前条数
    count: 30, //每次加载条数
  };
  loading.value = true;
  const res = await apiGetAppLog(data);
  loading.value = false;
  if (res.code === 0) {
    if (res.data.data) {
      res.data.data.forEach(log => {
        log.logtime = log.logtime.split('T')[0];
        if (dateMap[log.logtime]) {
          log.show = false;
        } else {
          log.show = true;
          dateMap[log.logtime] = true;
        }
      });
      logsData.push(...res.data.data);
    } else {
      hideLoadMore.value = true;
    }
  } else {
    $message.error(res.message);
  }
}
onMounted(() => {
  const endTime = new Date();
  const startTime = new Date(endTime.getTime() - 1000 * 60 * 60 * 24 * 30);
  dateRange.value = [startTime, endTime];
  if (currentProjectId.value) {
    getLogs();
  }
});
</script>
<style scoped>
.app-logs-root {
  height: 100%;
}

.datePicker {
  padding-left: 30px;
  padding-top: 20px;
}

.tip {
  display: inline-block;
  color: #696868;
}

.prompt {
  font-size: larger;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #696868;
}

.el-menu-demo {
  width: 97%;
  margin-left: 20px;
}

.logContent {
  box-shadow: 3px 3px 8px #bdbcbc;
  margin-left: 40px;
  margin-top: 20px;
  background-color: #fff;
  width: 95%;
  height: 79.5vh;
  overflow: auto;
}

.block {
  display: inline-block;
  margin-left: 5px;
  background-color: #fff;
  border-right: solid 1px var(--el-border-color);
}

.block:last-child {
  border-right: none;
}

.block .demonstration {
  display: block;
  color: var(--el-text-color-secondary);
  font-size: 14px;
  margin-bottom: 20px;
}

.el-card.is-always-shadow {
  margin-top: 30px;
  margin-bottom: 20px;
}
</style>
